import { SignUpForm } from './SignUpForm';
import { Link } from 'react-router-dom';

export function SignUpPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
      <Link to="/" className="mb-6 transition-opacity hover:opacity-80">
        <img src="/images/logo.png" alt="Top Match Talent Logo" className="h-10 w-auto" />
      </Link>
      <SignUpForm />
    </div>
  );
}